// Converts object keys from UpperCamelCase to lowerCamelCase
//
// Example:
// call: deserialiseData({ ObjectKey: 'value' })
// result: { objectKey: 'value' }
export const deserialiseData = <U, T>(data: U): T => {
  const convertedObject = {};
  Object.keys(data).forEach(key => {
    const convertedKey = `${key[0].toLowerCase()}${key.substr(1)}`;
    convertedObject[convertedKey] = data[key];
  });

  return convertedObject as T;
};
